import { ProductEnvironment } from '@atlassian/forge-ui-types';

export const getEnvironment = (): ProductEnvironment =>
  location.hostname.endsWith('bitbucket.org')
    ? ProductEnvironment.PRODUCTION
    : ProductEnvironment.STAGING;
